import localesPt from '@/views/Auth/i18n/localePt';

export default {
  pt: {
    ...localesPt.pt,
    SEO_TITLE: 'Você esqueceu sua senha',
    SEO_DESCRIPTION: 'Não te preocupes. Isso pode acontecer com todos nós.',
    FORM_TITLE: 'Restaurar senha',
    FORM_DESCRIPTION:
      'Digite o endereço de e-mail que você usou quando se inscreveu e enviaremos instruções para redefinir sua senha.',
    INPUT_EMAIL_LABEL: 'E-mail',
    INPUT_EMAIL_HINT: 'Digite seu e-mail',
    BUTTON_SUBMIT_LABEL: 'Mandar',
    SUCCESS_TITLE: '¡Preparar!',
    SUCCESS_DESCRIPTION:
      'Acabamos de enviar um e-mail com as instruções para \n [{{email}}](mailto:{{email}}). Siga as instruções para redefinir sua senha.',
    BUTTON_SUCCESS_LABEL: 'Iniciar sessão',
  },
};
